import { Component, inject, input } from '@angular/core';
import { Router } from '@angular/router';
import { TranslatePipe, TranslateService } from '@ngx-translate/core';
import { MenuItem } from 'primeng/api';
import { ButtonModule } from 'primeng/button';
import { MenuModule } from 'primeng/menu';

@Component({
  selector: 'app-language-switcher',
  imports: [ButtonModule, TranslatePipe, MenuModule],
  templateUrl: './language-switcher.html',
  styleUrl: './language-switcher.css',
})
export class LanguageSwitcher {
  translationService = inject(TranslateService);
  router = inject(Router);

  mobile = input<boolean>(false);

  items: MenuItem[] = [
    { label: 'EN', command: () => this.changeLanguage('en') },
    { label: 'DE', command: () => this.changeLanguage('de') },
    { label: 'FR', command: () => this.changeLanguage('fr') },
    { label: 'IT', command: () => this.changeLanguage('it') },
  ];

  // Routes without a lang prefix — language switch only updates the translation, not the URL
  private readonly unprefixedRoutes = ['/auth', '/profile', '/dealer', '/embed', '/demo-access'];

  changeLanguage(lang: string) {
    const url = this.router.url;

    const isUnprefixed = this.unprefixedRoutes.some(r => url.startsWith(r));
    if (isUnprefixed) {
      this.translationService.use(lang);
      return;
    }

    const newUrl = /^\/(en|de|fr|it)(\/|$)/.test(url)
      ? url.replace(/^\/(en|de|fr|it)(\/|$)/, `/${lang}$2`)
      : `/${lang}${url}`;
    this.router.navigateByUrl(newUrl);
  }
}
